"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelCheckButton = exports.getLabelPauseButton = exports.ERROR_SOUNDS = exports.BUTTON_LABELS = void 0;
exports.BUTTON_LABELS = {
    1: { start: "Старт", stop: "Стоп", check: "Проверить" },
    2: { start: "Start", stop: "Stop", check: "Check" },
    5: { start: "Boshlash", stop: "To'xtatish", check: "Tekshir" },
    6: { start: "Бастау", stop: "Тоқта", check: "Тексеру" } // kz казахский
};
exports.ERROR_SOUNDS = {
    1: {
        315: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Russian-error-315.mp3",
        316: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Russian-error-316.mp3",
        317: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Russian-error-317.mp3",
        318: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Russian-error-318.mp3",
        328: 'https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Russian-error-328.mp3',
    },
    2: {
        315: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/English-error-315.mp3",
        316: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/English-error-316.mp3",
        317: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/English-error-317.mp3",
        318: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/English-error-318.mp3",
    },
    5: {
        315: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Uzbek-error-315.mp3",
        316: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Uzbek-error-316.mp3",
        317: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Uzbek-error-317.mp3",
        318: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Uzbek-error-318.mp3",
    },
    6: {
        315: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Kazakh-error-315.mp3",
        316: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Kazakh-error-316.mp3",
        317: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Kazakh-error-317.mp3",
        318: "https://1624bf13-23ac-471a-a981-6ac9f3e96951.selstorage.ru/sound_errors/Kazakh-error-318.mp3",
    },
};
const getLabelPauseButton = (langId, isRecognizing, isPaused) => {
    const lang = exports.BUTTON_LABELS[+langId] || exports.BUTTON_LABELS[2];
    if (!isPaused) {
        return isRecognizing ? lang.stop : lang.start;
    }
    else
        return lang.stop;
};
exports.getLabelPauseButton = getLabelPauseButton;
const getLabelCheckButton = (langId) => { var _a, _b; return (_b = (_a = exports.BUTTON_LABELS[+langId]) === null || _a === void 0 ? void 0 : _a.check) !== null && _b !== void 0 ? _b : exports.BUTTON_LABELS[2].check; };
exports.getLabelCheckButton = getLabelCheckButton;
